import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@ngneat/transloco';
import { LibSharedCommonModule } from 'projects/lib-shared-common/src/public-api';
import { NotFound404Component } from './404.component';
import { SvcButtonsModule } from '@solvace/component/svc-buttons';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@NgModule({
  declarations: [
    NotFound404Component
  ],
  imports: [
    RouterModule,
    LibSharedCommonModule,
    MatProgressSpinnerModule,
    SvcButtonsModule,
    TranslocoModule
  ],
  exports: [
    NotFound404Component
  ]
})
export class NotFound404Module { }
